import {
  POPULAR_CITIES_RECEIVE_DATA,
  POPULAR_CITIES_RECEIVE_DATA_ERROR,
  POPULAR_CITIES_CLEAR_ERRORS,
} from '../constants/index';

const receivePopularCitiesDataSuccess = (value: any) => ({
  type: POPULAR_CITIES_RECEIVE_DATA,
  payload: { value },
});

const receivePopularCitiesDataError = (value: any) => ({
  type: POPULAR_CITIES_RECEIVE_DATA_ERROR,
  payload: { value },
});

const clearPopularCitiesError = () => ({ type: POPULAR_CITIES_CLEAR_ERRORS });

export { receivePopularCitiesDataSuccess, receivePopularCitiesDataError, clearPopularCitiesError };
